import React from 'react'
import ActivityCard from '../ActivityCard'
import PersonCard from '../PersonCard'
import RecommendedCard from '../RecommendedCard'

export default function CardType({ type, ...rest }) {
  if (type === 'recommended') {
    return <RecommendedCard {...rest} />
  }

  if (rest.person || type === 'person') {
    // We get a dataType of 'person' for the reservation people activity groups displayed on the temple tab, but we get a person object and dataType of 'question-answer' for ones we show on the "My Family Members" row on the /story tab.
    return <PersonCard {...rest} />
  }

  return <ActivityCard imgUrl={rest?.imageUrlSvg ?? rest?.imageUrl} {...rest} />
}
